export function initLegacy(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.WorkspaceLandingPageJsViewModel>) {
   let vpv = "/vpv/workspace-hourly";
   if (model.Workspace.ReservationMethod == LSCrossTier.WorkspaceReservationMethod.Period) {
      vpv = "/vpv/workspace-monthly";
   }


   let popUpSignInParams: Partial<LSHelper.Account.PopUpSignInOptions> | null = null;

   if (model.CompleteBookingModel != null) {
      popUpSignInParams =
      {
         joinMessage: "Sign up to book " + model.Workspace.Name + " at " + model.VenueFullName + ".",
         signInMessage: "Log in to book " + model.Workspace.Name + " at " + model.VenueFullName + ".",
         popupParams: {
            mode: model.CompleteBookingModel.Mode as LiquidSpace.View.LogonPopupMode,
            email: model.CompleteBookingModel.Email,
            fullName: model.CompleteBookingModel.FullName
         }
      };
   }
   else if (model.VenueStatusNew == LSCrossTier.VenueStatusNew.Internal && User.isAnonymous()) {
      let modeParam = (new URLSearchParams(window.location.search)).get("m") as LiquidSpace.View.LogonPopupMode;
      if (!modeParam || modeParam != "join") {
         modeParam = "signin";
      }
      popUpSignInParams = {
         joinMessage: "This location is visible to members only. Please log in to view availability and book a reservation.",//LSCommon.MemberNeedsPermissionsForVenueException.DefaultMessageJoin,
         signInMessage: "This location is visible to members only. Please sign up to view availability and book a reservation.",//LSCommon.MemberNeedsPermissionsForVenueException.DefaultMessage,
         popupParams: { mode: modeParam }
      };
   }

   return WLP.init(model, vpv, popUpSignInParams);
}
